import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, useTheme, Stack } from "@mui/material";
import { IRoadwayConfig } from "types";
import imgLamp from "assets/images/lamp-reference.png";
import imgLampRope from "assets/images/lamp-rope-reference.png";
import Row from "./Row";
import getStyles from "./styles";

interface LuminaireRowProps {
  delta: string;
  lph: string;
  overhang: string;
  tilt: string;
  maintenanceFactor: string;
  roadwayConfig: IRoadwayConfig;
  pos: string;
  n_lums: number | null;
}

const LuminaireRow: FC<LuminaireRowProps> = ({ delta, lph, overhang, tilt, maintenanceFactor, pos, n_lums, roadwayConfig }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).LuminaireRow, [theme]);

  const showNumberOfLuminaires = roadwayConfig.roadLength || n_lums;

  return (
    <Stack sx={styles.container}>
      <Box sx={styles.table}>
        <Typography variant="h3" sx={styles.title}>
          {t("Luminaire row")}
        </Typography>

        <Row label={t("Distance between poles")} value={`${delta} m`} />
        {!!showNumberOfLuminaires && <Row label={t("N of luminaires")} value={`${n_lums}`} />}
        <Row label={t("Height of the light point")} value={`${lph} m`} legend="H" />
        {pos !== "rope" && (
          <>
            <Row label={t("Overhang")} value={`${overhang} m`} legend="A" />
            <Row label={t("Tilt of the luminaire")} value={`${tilt}°`} legend="T" />
          </>
        )}
        <Row label={t("Maintenance factor")} value={`${maintenanceFactor} m`} />
      </Box>

      <Box component="img" src={pos === "rope" ? imgLampRope : imgLamp} alt="Luminaire Reference" sx={styles.image} />
    </Stack>
  );
};

export default LuminaireRow;
